import {request} from '@/helpers/apiClient'
import {ORDER_OVERVIEW_CONFIG} from '@/utils/constants/apiConfig/Order/OrderOverview/orderOverviewConfig'

export const getOrderOverview = queryParams => request(ORDER_OVERVIEW_CONFIG.ORDER_DETAIL, '', queryParams)

export const getOrderOfflineDetails = (queryParams, typeOfOrder) => request(ORDER_OVERVIEW_CONFIG.ORDER_OFFLINE_DETAILS(queryParams, typeOfOrder), {})

export const getOrderOnlineDetails = (queryParams, typeOfOrder) => request(ORDER_OVERVIEW_CONFIG.ORDER_ONLINE_DETAILS(queryParams, typeOfOrder), {})